import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../lib/api';

export function useActivityTracker() {
  const location = useLocation();
  const prevPath = useRef('');

  useEffect(() => {
    if (location.pathname !== prevPath.current) {
      prevPath.current = location.pathname;
      api.post('/track/visit', { page: location.pathname }).catch(() => {});
    }
  }, [location.pathname]);
}

export function trackAction(action, detail = '', page = '') {
  api.post('/track/action', { action, detail, page }).catch(() => {});
}
